import { Routes, Route } from "react-router-dom";
import PublicLayout from "../layouts/public/PublicLayout";
import AdminLayout from "../layouts/admin/AdminLayout";
import Home from "../pages/public/Home/Home";
import Login from "../pages/public/auth/Login";
import SkillMatrix from "../pages/public/SkillMatrix/SkillMatrix";
import AdminSkillMatrix from "../pages/admin/skill/AdminSkillMatrix";
import PersonasAdminPage from "../pages/admin/Personas";
import ProjectsPage from "../pages/public/Projects/ProjectsPage";
import ProjectsAdminPage from "../pages/admin/Projects/ProjectsAdminPage";
import TimelinePage from "../pages/public/Timeline/TimelinePage";
import TimelineAdmin from "../pages/admin/TimelineAdmin";
import RecoveryAdmin from "../pages/admin/Recovery/RecoveryAdmin";
import Security from "../pages/admin/Security";
import Dashboard from "../pages/admin/Dashboard/Dashboard";
import SystemLogs from "../pages/admin/SystemLogs/SystemLogs";

// NEW: Contact pages
import Contact from "../pages/public/Contact/Contact";
import ContactAdmin from "../pages/admin/ContactAdmin/ContactAdmin";
import ChatbotAdmin from "../pages/admin/Chatbot/ChatbotAdmin";

function NotFound() {
  return (
    <div style={{ textAlign: "center", padding: "4rem 1rem" }}>
      <h1>404</h1>
      <p>Sorry, the page you’re looking for does not exist.</p>
      <a href="/" style={{ color: "#4134e4" }}>Back to Home</a>
    </div>
  );
}

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<PublicLayout />}>
        <Route index element={<Home />} />
        <Route path="skill-matrix" element={<SkillMatrix />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="timeline" element={<TimelinePage />} />
        <Route path="contact" element={<Contact />} />
        <Route path="auth/login" element={<Login />} />
      </Route>

      {/* Admin Routes */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="personas" element={<PersonasAdminPage />} />
        <Route path="skills" element={<AdminSkillMatrix />} />
        <Route path="projects" element={<ProjectsAdminPage />} />
        <Route path="timeline" element={<TimelineAdmin />} />
        <Route path="recovery" element={<RecoveryAdmin />} />
        <Route path="security" element={<Security />} />
        {/* NEW: Contact/Profile Admin Management */}
        <Route path="contact" element={<ContactAdmin />} />
        {/* Chatbot Admin Config */}
        <Route path="chatbot" element={<ChatbotAdmin />} />
        {/* Activity / audit trail — placeholder until a backend log exists */}
        <Route path="activity" element={<SystemLogs />} />
      </Route>

      {/* 404 fallback */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}